import { createTheme } from '@mui/material';
import { AppThemeName, THEME_PREVIEW_COLORS } from '../../../styles/global.styles';

// createTheme() do MUI precisa de cores literais (faz lighten()/decomposeColor() em cima do valor) —
// não aceita string var(--app-*) direto, senão quebra em runtime com "MUI: Unsupported `var(...)`
// color". Por isso monta o palette com os valores literais de THEME_PREVIEW_COLORS (a mesma fonte
// que alimenta as CSS vars) em vez de passar var(--app-*) pro createTheme, igual ao buildTheme() de
// App.tsx.
export const buildDarkTheme = (themeName: AppThemeName) => {
  const c = THEME_PREVIEW_COLORS[themeName] ?? THEME_PREVIEW_COLORS.BLUE;

  return createTheme({
    palette: {
      mode: 'dark',
      primary: { main: c['--app-accent'] },
      background: { default: c['--app-bg'], paper: c['--app-surface-1'] },
      divider: c['--app-table-border'],
      text: { primary: c['--app-text'], secondary: c['--app-accent-muted'] },
      error: { main: '#ef4444' },
      warning: { main: '#f59e0b' }
    },
    typography: { fontFamily: 'Inter, sans-serif' },
  });
};

export const DAYS_OF_WEEK = [
  { id: 'Monday', labelKey: 'schoolShiftPage.days.monday' },
  { id: 'Tuesday', labelKey: 'schoolShiftPage.days.tuesday' },
  { id: 'Wednesday', labelKey: 'schoolShiftPage.days.wednesday' },
  { id: 'Thursday', labelKey: 'schoolShiftPage.days.thursday' },
  { id: 'Friday', labelKey: 'schoolShiftPage.days.friday' },
  { id: 'Saturday', labelKey: 'schoolShiftPage.days.saturday' },
  { id: 'Sunday', labelKey: 'schoolShiftPage.days.sunday' },
];